import React, {useState} from 'react'
import {makeStyles,SwipeableDrawer,IconButton, useTheme} from '@material-ui/core'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import logo from "../Images/Logo.PNG";
import ListItemText from '@material-ui/core/ListItemText';
import {CgMenuLeft} from 'react-icons/cg'
import { Link } from 'react-router-dom';
import {styled} from '@material-ui/core/styles'

const useStyles=makeStyles(theme=>({
    root: {
        width: '100%',
        height:'100vh',
        maxWidth: 360,
        backgroundColor: '#46516d',
        color:'#fff'
      },
}))

const NavLogo=styled('div')({
    width:'100%',
    height:'100px',
    display:'flex',
    justifyContent: 'center',
    alignItems:'center'
})

const Drawer = ({authenticated,data}) => {
    const classes=useStyles();
    const Theme=useTheme();
    const [openDrawer,setOpenDrawer]=useState(false);
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleListItemClick = (event, index) => {
      setSelectedIndex(index);
    };
    // console.log(data.professional)
    return (
        <React.Fragment>
        <SwipeableDrawer disableBackdropTransition={!iOS}  disableDiscovery={iOS}  open={openDrawer} onClose={()=>setOpenDrawer(false)} onOpen={()=>setOpenDrawer(true)}>
        <div style={{width:"260px"}}>
        <div className={classes.root}>
        <NavLogo>
              <Link to={"/"}>
              <img width='60px' height='50px' src={logo} className="logoimage" alt={"logo"}/>
              </Link>
        </NavLogo>

      <List component="nav" aria-label="main mailbox folders">
        <Link style={{textDecoration:'none',color:'#fff'}} to='/'>
        <ListItem
          button
          selected={selectedIndex === 0}
          onClick={(event) => handleListItemClick(event, 0)}
        >
          <ListItemText primary="Home" />
        </ListItem>
        </Link>
          {authenticated && <Link style={{textDecoration: 'none', color: '#fff'}} to='/requestservice'>
              <ListItem
                  button
                  selected={selectedIndex === 1}
                  onClick={(event) => handleListItemClick(event, 1)}
              >
                  <ListItemText primary="Request Service"/>
              </ListItem>
          </Link>
          }
          {!authenticated && <Link style={{textDecoration: 'none', color: '#fff'}} to='/register'>
              <ListItem
                  button
                  selected={selectedIndex === 1}
                  onClick={(event) => handleListItemClick(event, 1)}
              >
                  <ListItemText primary="Register"/>
              </ListItem>
          </Link>
          }
          {authenticated &&
          <Link style={{textDecoration: 'none', color: '#fff'}} to='/account'>
              <ListItem
                  button
                  selected={selectedIndex === 2}
                  onClick={(event) => handleListItemClick(event, 2)}
              >
                  <ListItemText primary="Account"/>
              </ListItem>
          </Link>}
          {authenticated && data.professional && <Link style={{textDecoration: 'none', color: '#fff'}} to='/requests'>
              <ListItem
                  button
                  selected={selectedIndex === 3}
                  onClick={(event) => handleListItemClick(event, 3)}
              >
                  <ListItemText primary="Requests"/>
              </ListItem>
          </Link>}
          <a href={"https://blog.aturservices.co.in"}>
          <ListItem
              button
              selected={selectedIndex === 4}
              onClick={(event) => handleListItemClick(event, 4)}
          >
              <ListItemText primary="Blog" />
          </ListItem>
          </a>
        <Link style={{textDecoration:'none',color:'#fff'}} to='/Pricing'>
        <ListItem
          button
          selected={selectedIndex === 4}
          onClick={(event) => handleListItemClick(event, 4)}
        >
          <ListItemText primary="Pricing" />
        </ListItem>
        </Link>

        <Link style={{textDecoration:'none',color:'#fff'}} to='/aboutus'>
        <ListItem
          button
          selected={selectedIndex === 5}
          onClick={(event) => handleListItemClick(event, 5)}
        >
          <ListItemText primary="About us" />
        </ListItem>
        </Link>
        </List>
    </div>
        </div>
        </SwipeableDrawer>
        <IconButton  onClick={()=>setOpenDrawer(!openDrawer)}>
        <CgMenuLeft style={{fontSize: 23,color:'#fff'}}/>
        </IconButton>
         </React.Fragment>
    )
}

export default Drawer
